var render = function render(){var _vm=this,_c=_vm._self._c;return _c('product',{attrs:{"title":"Amazfit 轻量保暖抓绒外套","swiper-data":_vm.swiperData,"slogan":_vm.slogan,"price":"99","colors":_vm.colors,"relatived-products":_vm.relativedProducts,"detail-images":_vm.detailImages,"param-images":_vm.paramImages,"buy-link":"https://shop18009901.m.youzan.com/wscgoods/detail/3nhvyulxl1nv9"}})
}
var staticRenderFns = []

export { render, staticRenderFns }